
define(
    'jsx!components/modal/export',[
        "jquery",
        "underscore",
        "backbone",
        "react",
        "actions/viewbuncee",
        "shared/user"
    ],
    function($,_,Backbone,React,ViewBunceeActions, User){
        var PDF_STATUS_NONE = 0;
        var PDF_STATUS_WORKING = 1;
        var PDF_STATUS_SUCCESS = 2;
        var PDF_STATUS_FAILED = -1;

        var waitMessages = [
            "Still working...",
            "Almost there...",
            "Just a moment longer...",
            "Almost done...",
        ];

        return React.createClass({
            displayName: "ExportModal",
            pdfJobKey: null,
            getInitialState: function()
            {
                return {
                    pdfURL: null,
                    retrievePDFStatus: PDF_STATUS_NONE,
                    waitMessage: null
                }
            },
            handleClickOnPDF: function(e)
            {
                if (!User.hasPermission("creation.download.pdf")){
                    console.log("User does not have permission to download a PDF.");
                    return;
                }

                if (this.state.retrievePDFStatus == PDF_STATUS_WORKING) {
                    console.log("There is already an active PDF request in progress.");
                    return;
                }

                var self = this;
                var guid = this.props.stores.buncee.getBuncee().guid;
            
                self.setState({
                    retrievePDFStatus: PDF_STATUS_WORKING,
                    pdfURL: null
                });

                window.api.request("buncees", guid, "pdf").create({}).done(function(response) {
                    self.pdfJobKey = response.job_key;

                    /*
                     * Ping until the PDF is ready
                     */
                    (function pingJobStatus(jobKey, attempt) {
                        if (jobKey !== self.pdfJobKey) {
                            console.log("Aborting ping for PDF job key %s. The key has changed.", jobKey);
                            return;
                        }

                        if (attempt > 60) {
                            self.pdfJobKey = null;
                            self.setState({
                                retrievePDFStatus: PDF_STATUS_FAILED,
                                pdfURL: null
                            });
                            console.log("Aborting ping for PDF job key %s. Exceeded maximum attempts.");
                            return;
                        }

                        if (attempt > 2) {
                            self.setState({
                                waitMessage: waitMessages[(attempt - 2) % waitMessages.length]
                            });
                        }

                        window.api.request("jobs", jobKey).execute()
                        .done(function (response, textStatus, jqXHR) {
                            var statusCode = jqXHR.statusCode().status;
                            if (statusCode == 200) {
                                try {
                                    var outputURL = response.data.output.url;
                                    if (outputURL) {
                                        self.setState({
                                            retrievePDFStatus: PDF_STATUS_SUCCESS,
                                            pdfURL: outputURL
                                        });
                                    }
                                } catch (error) {
                                    console.log(error);
                                    self.setState({
                                        retrievePDFStatus: PDF_STATUS_FAILED
                                    });
                                }
                            } else {
                                setTimeout(function () {
                                    pingJobStatus(jobKey, attempt + 1);
                                }, 1000 * 5);
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            var statusCode = jqXHR.statusCode().status;
                            console.error(textStatus, errorThrown, statusCode);

                            // 422 means the job failed. No point in re-pinging.
                            if (statusCode == 422) {
                                self.setState({
                                    retrievePDFStatus: PDF_STATUS_FAILED
                                });
                            } else {
                                setTimeout(function () {
                                    pingJobStatus(jobKey, attempt + 1);
                                }, 1000 * 5);
                            }
                        });
                    })(self.pdfJobKey, 1);
                });
            },
            componentWillMount : function()
            {
                this.actions = new ViewBunceeActions();
            },
            getPDF: function()
            {
                var pdf_url = this.actions.pdf_url;
                if(!pdf_url){
                    //>>includeStart("debug", pragmas.debug);
                    console.error("No PDF export URL");
                    //>>includeEnd("debug");
                    return;
                }

                // Ping the PDF url
                if(this.actions.getUserAgent().isMobileSafari()) {
                    location.href = pdf_url;
                } else {
                   window.open(pdf_url);
                }
            },
            done: function()
            {
                var parent = document.getElementById('buncee-modal');
                React.unmountComponentAtNode(parent);
                //this.props.model.done();
            },
            didClickOverlay: function(e)
            {
                this.done(e);
            },
            render: function()
            {
                var self = this;
                var styleWidth = {'width': '600px',position:'relartive'};
                var slides = this.props.stores.buncee.getBuncee().slides;
                var thumbs = this.props.stores.buncee.getBuncee().thumbnails;

                var thumbsBySlide = React.createElement("div", null, 
                     slides.map(function(slide, idx) {
                        if (User.isGenericFree) {
                            return (
                                React.createElement("div", {className: "exportThumb locked"}, 
                                    React.createElement("img", {src: thumbs[idx], width: "167", height: "94"}), 
                                    React.createElement("div", {className: "exportThumbTitle"}, "Slide ", idx + 1), 
                                    React.createElement("div", {className: "message-disable"}, "Please upgrade to access this feature.")
                                )
                            )
                        }

                        return (
                            React.createElement("div", {className: "exportThumb"}, 
                                React.createElement("a", {href: thumbs[idx], download: true}, 
                                    React.createElement("img", {src: thumbs[idx], width: "167", height: "94"})
                                ), 
                                React.createElement("div", {className: "exportThumbTitle"}, "Slide ", idx+1)
                            )
                        );
                    }));

                var styleAction = {'textAlign': 'left',  'overflowY': 'scroll', 'height': '300px'};

                var styleSectionTitle = {
                    'marginTop': '10px',
                    'textAlign': 'center'
                };

                var disabledStyle = "",
                    disabledIcon = null,
                    disabledMessage = null;
                var pdfHandler = this.handleClickOnPDF;

                if (!User.hasPermission("creation.download.pdf") || User.isGenericFree()) {
                    disabledStyle = " free-disabled-download";
                    disabledIcon = React.createElement("span", {className: "disabled-icon icons8-plus-math"});
                    disabledMessage = React.createElement("div", {className: "message-disable"}, "Please upgrade to access this feature.");
                    pdfHandler = null;
                }
                var thumbPDF = React.createElement("div", {className: "exportThumb exportPDF" + disabledStyle}, 
                    React.createElement("div", {onClick: pdfHandler, style: {textAlign: "center", paddingTop: "6px"}}, 
                        React.createElement("img", {src: "https://maxcdn.icons8.com/office/PNG/60/Files/pdf-60.png", alt: "PDF", height: "60px", width: "60px"}), 
                        React.createElement("div", null, "PDF")
                    ), 
                    disabledIcon, 
                    disabledMessage
                );

                var retrievingOverlay = null;
                if (!(this.state.retrievePDFStatus == PDF_STATUS_NONE)) {
                    var overlayStyle = {
                        "background" : "rgba(0,0,0,0.5)",
                        "width" : "100%",
                        "height" : "100%",
                        "top" : 0,
                        "left" : 0,
                        "textAlign" : "center",
                        "position" : "absolute",
                    };
                    
                    var innerContent;
                    

                    if (this.state.retrievePDFStatus == PDF_STATUS_WORKING) {
                        innerContent = (
                            React.createElement("div", null, 
                                React.createElement("h1", null, "Generating PDF"), 
                                React.createElement("div", {id: "preloaderDiv"}, React.createElement("img", {id: "preloadGIF", style: {height: "50px"}, src: "https://cdn.edu.buncee.com/rackspace/shared/loading-indicator-80x80.gif"})), 
                                React.createElement("h3", null,  this.state.waitMessage || "Please wait while the PDF is generated...")
                            ) 
                        );
                    } else if (this.state.retrievePDFStatus == PDF_STATUS_SUCCESS && self.state.pdfURL) {
                        innerContent = (
                            React.createElement("div", null, 
                                React.createElement("h1", null, "All Done!"), 
                                React.createElement("div", {className: "buncee-modal-buttons"}, 
                                    React.createElement("div", {className: "modal-button button-blue"}, 
                                        React.createElement("a", {href: self.state.pdfURL, target: self.actions.getUserAgent().isMobileSafari() ? "_self" : "_blank"}, "Open PDF")
                                   ), 
                                    React.createElement("div", {className: "modal-button button-red", onClick:  function () {
                                        self.setState({
                                            retrievePDFStatus: PDF_STATUS_NONE,
                                            pdfURL: null
                                        });
                                    }}, 
                                        "Close"
                                   )
                                )
                            )
                        );
                    } else if (this.state.retrievePDFStatus == PDF_STATUS_FAILED) {
                        innerContent = (
                            React.createElement("div", null, 
                                React.createElement("h1", null, "Request Failed"), 
                                React.createElement("h4", null, "We were unable to generate your PDF at this time. Please try again, or contact support."), 
                                React.createElement("div", {className: "buncee-modal-buttons"}, 
                                    React.createElement("div", {className: "modal-button button-blue", onClick: function () {
                                        self.setState({
                                            retrievePDFStatus: PDF_STATUS_NONE,
                                            pdfURL: null
                                        });
                                        self.handleClickOnPDF();
                                    }}, 
                                        "Try Again"
                                   ), 
                                    React.createElement("div", {className: "modal-button button-red", onClick:  function () {
                                        self.setState({
                                            retrievePDFStatus: PDF_STATUS_NONE,
                                            pdfURL: null
                                        });
                                    }}, 
                                        "Close"
                                   )
                                )
                            )
                        );
                    }

                    retrievingOverlay = (
                        React.createElement("div", {style: overlayStyle}, 
                            React.createElement("div", {style: {background:"#fff",padding:"10px",width:"430px","position":"relative","top":"110px","left":"75px"}}, 
                                innerContent
                            )
                        )
                    )
                    
                }
                return (
                    React.createElement("div", null, 
                        React.createElement("div", {className: "buncee-modal", style: styleWidth}, 
                            React.createElement("div", {className: "buncee-modal-title"}, "Download"), 
                            React.createElement("div", {className: "buncee-modal-action", style: styleAction}, 
                                React.createElement("div", null, 
                                    React.createElement("div", {style: styleSectionTitle}, React.createElement("label", null, "All Slides")), 
                                    thumbPDF
                                ), 
                                React.createElement("div", {style: styleSectionTitle}, React.createElement("label", null, "Slide Images")), 
                                thumbsBySlide
                            ), 
                            React.createElement("div", {className: "buncee-modal-buttons"}, 
                                React.createElement("div", {className: "modal-button", onClick: this.done}, "DONE")
                            ), 
                            retrievingOverlay
                        ), 
                        React.createElement("div", {id: "overlay", onClick: this.didClickOverlay})
                    )
                )
            }
        });
    }
);
